// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipping_length[data-v-ebc71d42]{font-weight:600;font-size:14px;padding:10px 20px;border:1px solid #cbc8c3;background-color:#f2f2f2;border-radius:10px;display:inline-block}", ""]);
// Exports
module.exports = exports;
